import { useQuery } from '@tanstack/react-query';
import { Check } from 'lucide-react';
import { Navigate } from 'react-router';
import { PageMotion } from 'src/components/layout/page-motion.tsx';
import { useDynamicsForm } from 'src/hooks/use-dynamics-form.ts';
import apiClient from 'src/lib/apiClient.ts';
import { useCheck } from 'src/state/check-context.ts';

import { Eyebrow } from '../components/ui/eyebrow.tsx';

export function LeadPage() {
  const { answers } = useCheck();

  const { data: arcIdData } = useQuery({
    queryKey: ['arc-id'],
    queryFn: () =>
      apiClient.get<{ resultId: number }>('/results/next-id').then((r) => String(r.data.resultId)),
    staleTime: Infinity
  });

  useDynamicsForm(arcIdData);

  if (Object.keys(answers).length === 0) return <Navigate to="/" replace />;

  return (
    <PageMotion>
      <div className="mx-auto max-w-5xl px-5 lg:px-10 py-12 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <Eyebrow>Ihre Auswertung</Eyebrow>
          <h2
            className="mt-4 text-title-lg sm:text-heading leading-tight tracking-tight text-zeb-tertiary"
            style={{
              fontFamily: 'var(--font-heading)',
              fontWeight: 700,
              letterSpacing: '-0.02em'
            }}>
            Aussagekräftiger Vergleich mit anderen Organisationen.
          </h2>
          <p
            className="mt-5 text-body-sm leading-relaxed text-zeb-gray-600"
            style={{ fontFamily: 'var(--font-body)', fontWeight: 500 }}>
            In den nächsten Monaten sammeln wir systematisch den Reifegrad von Finanzdienstleistern
            im deutschsprachigen Raum. Hinterlassen Sie Ihre Kontaktdaten – Sie erhalten einen
            individuellen Bericht mit Ihrem Reifegrad im Vergleich zur Benchmark und den daraus
            abgeleiteten Handlungsfeldern.
          </p>
          <ul className="mt-8 space-y-3 text-note text-zeb-gray-700">
            {[
              'Individueller Reifegrad-Bericht',
              'Benchmark gegen vergleichbare Häuser',
              'Konkrete Handlungsfelder je Framework-Ebene'
            ].map((b) => (
              <li key={b} className="flex items-start gap-3">
                <Check className="mt-0.5 h-4 w-4 text-zeb-primary shrink-0" />
                {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg border border-zeb-muted bg-white p-7 lg:p-9 shadow-zeb-md">
            <div
              data-form-id="dad56317-9364-f111-a826-6045bd9eca09"
              data-form-api-url="https://public-eur.mkt.dynamics.com/api/v1.0/orgs/38925aff-f9c4-448e-b83c-738a7f3c0bd3/landingpageforms"
              data-cached-form-url="https://assets-eur.mkt.dynamics.com/38925aff-f9c4-448e-b83c-738a7f3c0bd3/digitalassets/forms/dad56317-9364-f111-a826-6045bd9eca09"
            />
          </div>
        </div>
      </div>
    </PageMotion>
  );
}
